"use client";
import { jsx as g } from "react/jsx-runtime";
import { memo as n } from "react";
import { A as u, r as e, p as s, l as v } from "../../index-BHXiaNZf.js";
import y from "classnames";
import { getCloudinaryImage as _ } from "../../constants/cloudinary.js";
import '../../assets/Img.css';const p = "_img_18wgf_2", I = "_fill_18wgf_6", i = {
  img: p,
  fill: I
}, N = n(({ publicId: d, fill: c, priority: l, objectFit: o = "cover", objectPosition: t, steps: a = 800, quality: r, ...m }) => {
  const { style: f } = m;
  return /* @__PURE__ */ g(
    u,
    {
      ...m,
      className: y(i.img, { [i.fill]: c }, m.className),
      decoding: l ? void 0 : "async",
      fetchPriority: l ? "high" : void 0,
      style: { objectFit: o !== "fromClassName" ? o : void 0, objectPosition: t, ...f },
      cldImg: _(d, r),
      loading: l ? void 0 : "lazy",
      plugins: l ? [e({ steps: a }), s({ mode: "blur" })] : [v(), e({ steps: a }), s({ mode: "blur" })]
    }
  );
});
N.displayName = "Img";
export {
  N as default
};
